import { inject, Injectable, type TemplateRef, ViewContainerRef } from '@angular/core';
import {
    type BrnDialogOptions, BrnDialogRef,
    BrnDialogService,
    cssClassesToArray,
    DEFAULT_BRN_DIALOG_OPTIONS
} from '@spartan-ng/ui-dialog-brain';
import { uniqueId } from 'lodash';

import { HlmDialogContentComponent } from './hlm-dialog-content.component';
import { hlmDialogOverlayClass } from './hlm-dialog-overlay.directive';

import type { ComponentType } from '@angular/cdk/portal';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type HlmDialogOptions<DialogContext = any> = BrnDialogOptions & {
    contentClass?: string;
    context?: DialogContext;
};

@Injectable({
    providedIn: 'root'
})
export class HlmDialogService extends BrnDialogService {
    public openComponent(component: ComponentType<unknown> | TemplateRef<unknown>, options?: Partial<HlmDialogOptions>) {
        options = {
            ...DEFAULT_BRN_DIALOG_OPTIONS,
            closeDelay: 100,
            // eslint-disable-next-line
            ...(options ?? {}),
            backdropClass: cssClassesToArray(`${hlmDialogOverlayClass} ${options?.backdropClass ?? ''}`),
            context: { ...options?.context, $component: component, $dynamicComponentClass: options?.contentClass }
        };

        return this.open(HlmDialogContentComponent, undefined, options.context, options);
    }

    override open<DialogContext>(content: ComponentType<unknown> | TemplateRef<unknown>, vcr?: ViewContainerRef, context?: DialogContext, options?: Partial<BrnDialogOptions>): BrnDialogRef<any> {
        return super.open(content, vcr, context, { id: uniqueId('hlm-dialog-'), ...options });
    }
}
